import { useEffect } from 'react';

import { reportOperationLog } from '@gp/services/global';
import { ALL_REPORT_OPERATION_LOG } from '@gp/constants/operationLogParams';
// 按钮打点方法
export { reportBtnOperationLog } from '@gp/utils/common';

/**
 * 页面打点
 * @param params 页面打点配置
 */
export default function usePageLog(params: {
  // 页面Id，即ALL_REPORT_OPERATION_LOG配置中的key
  pageId: string;
  // id体系
  uidType?: string;
  // id
  uid?: string;
  // extInfo
  extInfo?: string;
  [key: string]: any;
}) {
  const { pageId, uidType, uid, extInfo } = params || {};

  useEffect(() => {
    if (!pageId) return;
    reportOperationLog({
      ...ALL_REPORT_OPERATION_LOG?.[pageId],
      uidType: uidType || '',
      uid: uid || '',
      extInfo: extInfo || '',
      query: '',
    });
  }, []);
}
